import { cn as e } from "../shared/utils.js";
import { OverflowProvider as t } from "../shared/overflow/overflow-context.js";
import { useOverflowContainer as n } from "../shared/overflow/use-overflow-container.js";
import { useOverflowItem as r } from "../shared/overflow/use-overflow-item.js";
import { useOverflowMenu as i } from "../shared/overflow/use-overflow-menu.js";
import { Checkbox as a } from "../checkbox/primitive/index.js";
import { CheckIcon as o, PlusIcon as s, XCircleFillIcon as c, XCloseIcon as l } from "@systemeio/icons";
import * as u from "react";
import { forwardRef as d } from "react";
import { Fragment as f, jsx as p, jsxs as m } from "react/jsx-runtime";
import { cva as h } from "class-variance-authority";
import { Field as g } from "@base-ui/react/field";
import { Select as _ } from "@base-ui/react/select";
//#region src/select/select-primitive.tsx
var v = h([
	"group/select-trigger flex w-full min-w-0 items-center justify-between gap-0.5 rounded-md border border-field-border bg-field-bg-primary text-left text-text-primary outline-none transition-base text-base",
	"data-[size=md]:px-3 data-[size=sm]:px-2",
	"placeholder:text-text-tertiary",
	"data-popup-open:border-field-border-active data-popup-open:shadow-field-border-active",
	"focus-visible:border-field-border-active focus-visible:shadow-field-border-active",
	"hover:border-field-border-hover",
	"data-disabled:bg-field-bg-disabled data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled data-disabled:cursor-not-allowed",
	"data-invalid:border-field-border-error data-invalid:shadow-field-border-error",
	"data-invalid:focus-visible:border-field-border-error data-invalid:focus-visible:shadow-field-border-error",
	"data-invalid:data-popup-open:border-field-border-error data-invalid:data-popup-open:shadow-field-border-error",
	"data-warning:border-border-warning data-warning:shadow-field-border-warning",
	"data-warning:focus-visible:border-border-warning data-warning:focus-visible:shadow-field-border-warning",
	"data-warning:data-popup-open:border-border-warning data-warning:data-popup-open:shadow-field-border-warning",
	"has-data-[overflow-mode=expanded]:h-auto has-data-[overflow-mode=expanded]:items-start",
	"data-group-control:h-full data-group-control:min-w-0 data-group-control:flex-1 data-group-control:rounded-none data-group-control:border-0 data-group-control:bg-transparent data-group-control:shadow-none",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: { size: {
		sm: "h-8 min-h-8 py-1.5 has-data-[overflow-mode=collapsed]:py-[calc(0.25rem-1px)] has-data-[overflow-mode=expanded]:min-h-8 has-data-[overflow-mode=expanded]:py-[calc(0.25rem-1px)]",
		md: "h-10 min-h-10 py-2.5 has-data-[overflow-mode=collapsed]:py-[calc(0.375rem-1px)] has-data-[overflow-mode=expanded]:min-h-10 has-data-[overflow-mode=expanded]:py-[calc(0.375rem-1px)]"
	} },
	defaultVariants: { size: "md" }
}), y = u.createContext(!1);
function b(e) {
	return /* @__PURE__ */ p(y.Provider, {
		value: !!e.multiple,
		children: /* @__PURE__ */ p(_.Root, { ...e })
	});
}
var x = d(({ className: t, required: n, ...r }, i) => /* @__PURE__ */ p(_.Label, {
	ref: i,
	"data-slot": "select-label",
	"data-testid": "select-label",
	"data-required": n || void 0,
	className: e("text-text-secondary data-required:after:text-text-error flex items-start text-base font-medium data-required:after:ml-0.5 data-required:after:content-['*']", t),
	...r
})), S = h("text-base", {
	variants: { tone: {
		default: "text-text-secondary",
		warning: "text-text-warning"
	} },
	defaultVariants: { tone: "default" }
}), C = d(({ className: t, tone: n, ...r }, i) => /* @__PURE__ */ p("p", {
	ref: i,
	"data-slot": "select-description",
	"data-testid": "select-description",
	className: e(S({ tone: n }), t),
	...r
}));
C.displayName = "SelectPrimitive.Description";
var w = d(({ className: t, ...n }, r) => /* @__PURE__ */ p("p", {
	ref: r,
	"data-slot": "select-error",
	"data-testid": "select-error",
	role: "alert",
	className: e("text-text-error text-base", t),
	...n
}));
w.displayName = "SelectPrimitive.Error";
var T = d(({ className: t, size: n = "md", unstyled: r, ...i }, a) => r ? /* @__PURE__ */ p(_.Trigger, {
	ref: a,
	"data-slot": "select-trigger",
	"data-testid": "select-trigger",
	"data-unstyled": "",
	className: t,
	...i
}) : /* @__PURE__ */ p("div", {
	"data-slot": "select-trigger-shell",
	"data-testid": "select-trigger-shell",
	"data-size": n,
	className: "relative w-full min-w-0",
	children: /* @__PURE__ */ p(_.Trigger, {
		ref: a,
		"data-slot": "select-trigger",
		"data-testid": "select-trigger",
		"data-size": n,
		className: e(v({ size: n }), t),
		...i
	})
})), E = d(({ className: t, ...n }, r) => /* @__PURE__ */ p("div", {
	ref: r,
	"data-slot": "select-field",
	"data-testid": "select-field",
	className: e("group/select-group group-focus-ring transition-base bg-field-bg-primary relative inline-flex w-full min-w-0 items-center rounded-md outline-none", "has-data-disabled:bg-field-bg-disabled", t),
	...n
}));
E.displayName = "SelectPrimitive.Field";
var D = d(({ className: t, children: n, description: r, ...i }, a) => /* @__PURE__ */ m("div", {
	ref: a,
	"data-slot": "select-empty",
	"data-testid": "select-empty",
	className: e("flex flex-col items-start gap-1 px-3 py-4", t),
	...i,
	children: [r != null && r !== "" && /* @__PURE__ */ p("span", {
		"data-slot": "select-empty-description",
		"data-testid": "select-empty-description",
		className: "text-text-secondary w-full text-sm",
		children: r
	}), n != null && n !== "" && /* @__PURE__ */ p("span", {
		"data-slot": "select-empty-title",
		"data-testid": "select-empty-title",
		className: "text-text-primary w-full text-base",
		children: n
	})]
}));
D.displayName = "SelectPrimitive.Empty";
var O = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.Value, {
	ref: r,
	"data-slot": "select-value",
	"data-testid": "select-value",
	className: e("text-text-primary data-placeholder:text-text-tertiary group-data-disabled/select-trigger:text-text-disabled line-clamp-1 min-w-0 flex-1 text-left text-base", t),
	...n
})), k = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.Icon, {
	ref: r,
	"data-slot": "select-icon",
	"data-testid": "select-icon",
	className: e("text-field-icon group-data-disabled/select-trigger:text-text-disabled flex size-5 shrink-0 items-center justify-center transition-transform duration-200 ease-out data-popup-open:rotate-180 [&>svg]:size-5", t),
	...n
})), A = _.Portal, j = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.Backdrop, {
	ref: r,
	"data-slot": "select-backdrop",
	"data-testid": "select-backdrop",
	className: e("bg-alpha-gray-alpha-gray-25 fixed inset-0 z-40 opacity-0 transition-opacity data-open:opacity-100", t),
	...n
})), M = d(({ className: t, sideOffset: n = 4, alignItemWithTrigger: r = !1, ...i }, a) => /* @__PURE__ */ p(_.Positioner, {
	ref: a,
	"data-slot": "select-positioner",
	"data-testid": "select-positioner",
	sideOffset: n,
	alignItemWithTrigger: r,
	className: e("z-50 outline-none", t),
	...i
})), N = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.Popup, {
	ref: r,
	"data-slot": "select-popup",
	"data-testid": "select-popup",
	className: e("bg-bg-primary text-text-primary border-border-100 shadow-1 rounded-md border py-1 outline-none", "flex max-h-[min(268px,var(--available-height))] w-(--anchor-width) min-w-[160px] flex-col overflow-hidden", "data-starting-style:scale-95 data-starting-style:opacity-0", "data-ending-style:scale-95 data-ending-style:opacity-0", "origin-(--transform-origin) transition-[transform,opacity] duration-100 ease-out", t),
	...n
})), P = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.List, {
	ref: r,
	"data-slot": "select-list",
	"data-testid": "select-list",
	className: e("min-h-0 flex-1 overflow-y-auto overscroll-contain", "*:data-[slot='select-group']:flex *:data-[slot='select-group']:flex-col *:data-[slot='select-group']:gap-0", t),
	...n
})), F = h([
	"group relative flex w-full min-w-0 cursor-pointer flex-row items-center px-4 py-3 text-base outline-none select-none",
	"text-text-primary hover:bg-bg-tertiary data-highlighted:bg-bg-tertiary data-selected:bg-bg-accent-light",
	"data-disabled:text-text-disabled data-disabled:cursor-not-allowed",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: { multiple: {
		true: "gap-2",
		false: "gap-1"
	} },
	defaultVariants: { multiple: !1 }
}), I = d(({ className: t, ...n }, r) => {
	let i = u.useContext(y);
	return /* @__PURE__ */ p(_.Item, {
		ref: r,
		"data-slot": "select-item",
		"data-testid": "select-item",
		className: e(F({ multiple: i }), t),
		...n
	});
}), L = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.ItemText, {
	ref: r,
	"data-slot": "select-item-text",
	"data-testid": "select-item-text",
	className: e("line-clamp-2 min-w-0 flex-1", "[&_svg:not([class*=size-])]:size-5", t),
	...n
})), R = d(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ p(_.ItemIndicator, {
	ref: i,
	"data-slot": "select-item-indicator",
	"data-testid": "select-item-indicator",
	className: e("flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", "transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0", t),
	...r,
	children: n ?? /* @__PURE__ */ p(o, {})
})), z = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.Group, {
	ref: r,
	"data-slot": "select-group",
	"data-testid": "select-group",
	className: e("flex flex-col gap-0", t),
	...n
})), B = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.GroupLabel, {
	ref: r,
	"data-slot": "select-group-label",
	"data-testid": "select-group-label",
	className: e("text-text-secondary flex w-full items-center justify-center pt-3 text-sm font-normal uppercase", t),
	...n
})), V = d(({ className: t, ...n }, r) => /* @__PURE__ */ p(_.Separator, {
	ref: r,
	"data-slot": "select-separator",
	"data-testid": "select-separator",
	className: e("bg-border-100 mx-3 h-px shrink-0", t),
	...n
})), H = d(({ className: r, mode: i = "collapsed", padding: a = 4, ...o }, s) => {
	let c = i === "fixed", l = c || i === "collapsed" ? "collapsed" : "expanded", { containerRef: u, contextValue: d } = n({ padding: a });
	return /* @__PURE__ */ p(t, {
		value: d,
		children: /* @__PURE__ */ p("div", {
			ref: (e) => {
				u.current = e, typeof s == "function" ? s(e) : s && (s.current = e);
			},
			"data-slot": "select-chips",
			"data-testid": "select-chips",
			"data-overflow-mode": l,
			"data-multi-layout": c ? "fixed" : void 0,
			className: e("flex min-w-0 flex-1 items-center gap-1", l === "collapsed" ? "flex-nowrap overflow-hidden" : "flex-wrap", r),
			...o
		})
	});
});
H.displayName = "SelectPrimitive.Chips";
var U = h([
	"inline-flex shrink-0 items-center gap-1.5 self-center rounded-full bg-palette-blue-bg px-2.5 py-1 text-base group-data-[size=sm]/select-trigger:px-1.5 group-data-[size=sm]/select-trigger:text-sm font-normal whitespace-nowrap text-palette-blue-textandicon",
	"in-data-[overflow-mode=expanded]:max-w-full in-data-[overflow-mode=expanded]:rounded-[14px] group-data-[size=sm]/select-trigger:in-data-[overflow-mode=expanded]:rounded-xl in-data-[overflow-mode=expanded]:text-start in-data-[overflow-mode=expanded]:wrap-anywhere in-data-[overflow-mode=expanded]:whitespace-normal",
	"[&>svg:not([class*=size-])]:size-4"
], {
	variants: { variant: {
		tag: "",
		ghost: "bg-transparent text-text-primary"
	} },
	defaultVariants: { variant: "tag" }
}), W = d(({ className: t, variant: n, id: i, ...a }, o) => {
	let s = r(i);
	return /* @__PURE__ */ p("span", {
		ref: (e) => {
			s.current = e, typeof o == "function" ? o(e) : o && (o.current = e);
		},
		"data-slot": "select-chip",
		"data-testid": "select-chip",
		"data-variant": n,
		className: e(U({ variant: n }), t),
		...a
	});
});
W.displayName = "SelectPrimitive.Chip";
var G = d(({ className: t, onClick: n, onMouseDown: r, ...i }, a) => {
	let o = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	};
	return /* @__PURE__ */ p("span", {
		ref: a,
		role: "button",
		tabIndex: -1,
		"data-slot": "select-chip-remove",
		"data-testid": "select-chip-remove",
		onClick: (e) => {
			o(e), n?.(e);
		},
		onMouseDown: (e) => {
			o(e), r?.(e);
		},
		className: e("text-palette-blue-textandicon hover:bg-palette-blue-textandicon/10 -m-1 flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full p-1 outline-none [--icon-color-tertiary:var(--color-bg-primary)] [&>svg]:size-4", t),
		...i,
		children: /* @__PURE__ */ p(c, {})
	});
});
G.displayName = "SelectPrimitive.ChipRemove";
var K = d(({ className: t, children: n, onClick: r, onMouseDown: a, ...o }, s) => {
	let { ref: c, overflowCount: l, isOverflowing: u } = i(), d = (e) => {
		c.current = e, typeof s == "function" ? s(e) : s && (s.current = e);
	}, f = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	}, m = r != null, h = !u;
	return /* @__PURE__ */ p("span", {
		ref: d,
		"data-slot": "select-overflow-badge",
		"data-testid": "select-overflow-badge",
		"aria-hidden": h || void 0,
		style: h ? { visibility: "hidden" } : void 0,
		onClick: m ? (e) => {
			f(e), r?.(e);
		} : void 0,
		onMouseDown: (e) => {
			m && f(e), a?.(e);
		},
		className: e("text-text-link inline-flex shrink-0 cursor-pointer items-center gap-0.5 self-center rounded-[48px] px-2 py-1 text-base font-medium select-none group-data-[size=sm]/select-trigger:text-sm", t),
		...o,
		children: n ?? `+${l}`
	});
});
K.displayName = "SelectPrimitive.OverflowBadge";
var q = d(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ p("span", {
	ref: i,
	"data-slot": "select-leading-icon",
	"data-testid": "select-leading-icon",
	"aria-hidden": "true",
	className: e("text-text-tertiary inline-flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", t),
	...r,
	children: n
}));
q.displayName = "SelectPrimitive.LeadingIcon";
var J = d(({ className: t, checked: n = !1, ...r }, i) => /* @__PURE__ */ p(g.Root, {
	className: "contents",
	children: /* @__PURE__ */ p(a.Root, {
		ref: i,
		"data-slot": "select-item-checkbox",
		"data-testid": "select-item-checkbox",
		checked: n,
		size: "md",
		tabIndex: -1,
		"aria-hidden": !0,
		className: e("pointer-events-none", t),
		...r,
		children: /* @__PURE__ */ p(a.Indicator, { size: "md" })
	})
}));
J.displayName = "SelectPrimitive.ItemCheckbox";
var Y = d(({ className: t, onClick: n, onMouseDown: r, children: i, ...a }, o) => {
	let s = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	};
	return /* @__PURE__ */ p("span", {
		ref: o,
		role: "button",
		tabIndex: -1,
		"data-slot": "select-clear",
		"data-testid": "select-clear",
		onClick: (e) => {
			s(e), n?.(e);
		},
		onMouseDown: (e) => {
			s(e), r?.(e);
		},
		className: e("text-field-icon hover:text-icon-primary flex size-5 shrink-0 cursor-pointer items-center justify-center outline-none [&>svg]:size-5", t),
		...a,
		children: i ?? /* @__PURE__ */ p(l, {})
	});
});
Y.displayName = "SelectPrimitive.Clear";
var X = d(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ p("div", {
	ref: i,
	"data-slot": "select-popup-action",
	"data-testid": "select-popup-action",
	className: e("border-border-100 text-text-link flex items-center gap-2 border-t px-4 py-3 text-base font-medium", t),
	...r,
	children: n ?? /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p(s, { className: "size-5" }), "Button"] })
}));
X.displayName = "SelectPrimitive.PopupAction", x.displayName = "SelectPrimitive.Label", T.displayName = "SelectPrimitive.Trigger", O.displayName = "SelectPrimitive.Value", k.displayName = "SelectPrimitive.Icon", j.displayName = "SelectPrimitive.Backdrop", M.displayName = "SelectPrimitive.Positioner", N.displayName = "SelectPrimitive.Popup", P.displayName = "SelectPrimitive.List", I.displayName = "SelectPrimitive.Item", L.displayName = "SelectPrimitive.ItemText", R.displayName = "SelectPrimitive.ItemIndicator", z.displayName = "SelectPrimitive.Group", B.displayName = "SelectPrimitive.GroupLabel", V.displayName = "SelectPrimitive.Separator";
var Z = {
	Root: b,
	Label: x,
	Description: C,
	Error: w,
	Trigger: T,
	Field: E,
	Value: O,
	Icon: k,
	Portal: A,
	Backdrop: j,
	Positioner: M,
	Popup: N,
	PopupAction: X,
	List: P,
	Item: I,
	ItemText: L,
	ItemIndicator: R,
	Empty: D,
	Group: z,
	GroupLabel: B,
	Separator: V,
	Chips: H,
	Chip: W,
	ChipRemove: G,
	OverflowBadge: K,
	LeadingIcon: q,
	ItemCheckbox: J,
	Clear: Y
};
//#endregion
export { Z as SelectPrimitive, U as selectChipVariants, S as selectDescriptionVariants, F as selectItemVariants, v as selectTriggerVariants };
